<template>
    <v-btn id="whats-new-btn" :class="{'--active': isWhatsNewDrawerOpen, 'animation-flash': whatsNewButtonAnimation}"
           v-tippy content="What's new?"
           @click="toggleWhatsNewDrawer">
        <v-icon class="material-symbols-outlined">
            news
        </v-icon>
    </v-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState('UI', ['isWhatsNewDrawerOpen', 'whatsNewButtonAnimation'])
    },

    methods: {
        toggleWhatsNewDrawer() {
            this.$store.commit('UI/TOGGLE_WHATS_NEW_DRAWER', true);
            localStorage.setItem('whats-new-2.2-opened', 1);
        }
    }
}
</script>

<style lang="scss" scoped>
#whats-new-btn {
    min-width: auto;
    height: auto;
    box-shadow: none;
    background-color: transparent;
    color: var(--font-default-color);
    padding: 3px;

    &--active {
        &::before {
            background-color: var(--color-accent);
            opacity: 0.4;
        }
    }

    &--disabled,
    &--disabled .v-icon {
        background-color: transparent !important;
        color: var(--font-default-color) !important;
        opacity: 0.4;
    }

    &.animation-flash {
        animation: button-flash 1s infinite ease-in-out;
    }

    i {
        font-size: 1.7rem;
    }
}
</style>